import { Col, Row } from 'react-bootstrap';
import styles from './new-user.module.scss';

export const NewUserWithoutAdminSubmitted = () => (
  <Row>
    <Col className={styles['submitted']}>
      <div className={styles['submitted-check']}>
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden>
          <path
            d="M5 12.5l4.5 4.5L19 7.5"
            stroke="#1f3d2f"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <p className={`header ${styles['submitted-header']}`}>
        SPINS has received your request
      </p>
      <p className={'subtext'}>
        We will notify you via email with further instructions after we conclude
        our investigation.
      </p>
    </Col>
  </Row>
);
